import { Loader, Stack } from '@mantine/core'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { propertyHooks } from '../../lib/trpcHooks/propertyHooks'
import { AppPage } from '@markku/components'

function MaintenanceServicesRedirect() {
  const { t } = useLingui()
  const navigate = useNavigate()
  const { data: propertiesData } = propertyHooks.useList()

  useEffect(() => {
    if (propertiesData) {
      const firstProperty = propertiesData.data?.[0]

      if (firstProperty) {
        // Redirect to property page with package tab
        navigate({
          to: '/properties/$propertyId',
          params: { propertyId: firstProperty.id.toString() },
          search: { tab: 'package' },
          replace: true,
        })
      } else {
        // No properties - redirect to profile
        navigate({ to: '/profile', replace: true })
      }
    }
  }, [propertiesData, navigate])

  return (
    <AppPage title={t`Markku packages`} backTarget="/profile">
      <Stack align="center" justify="center" h={200}>
        <Loader size="lg" />
      </Stack>
    </AppPage>
  )
}

export const Route = createFileRoute('/_app/maintenance-services')({
  component: MaintenanceServicesRedirect,
})
